/**
 * Vuely Global Components
 */
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import {
  RotateSquare2
} from "vue-loading-spinner";

// App section loader
import AppSectionLoader from "@/components/AppSectionLoader/AppSectionLoader";
// App Card component
import AppCard from '@/components/AppCard/AppCard';
// User profile
import UserProfile from "@/components/UserProfile/UserProfile";
//Loading
import Loading from "@/components/Loading/Loading";
//Snackbar
import SnackBar from "@/components/SnackBar/SnackBar";
import SearchBar from "@/components/SearchBar/SearchBar";

//ChatSofia
import ChatSofia from "@/components/ChatSofia/ChatSofia";

// router
import router from "./router";
/* 
// navigation guards before each
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (localStorage.getItem("accessToken") === null) {
      next({
        path: "/session/login",
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
}); */

const GlobalComponents = {
  install(Vue) {
    Vue.component("vuePerfectScrollbar", VuePerfectScrollbar);
    Vue.component("rotateSquare2", RotateSquare2);
    Vue.component('appSectionLoader', AppSectionLoader);
    Vue.component('AppCard', AppCard);
    Vue.component('UserProfile', UserProfile);
    Vue.component('Loading', Loading);
    Vue.component('SnackBar', SnackBar);
    Vue.component('SearchBar',SearchBar);    
  }
};

export default GlobalComponents;